import {
  emailIsValid,
  validateStringExists
} from '../../Components/Utilities/ValidationHelper/validationHelpers';

export const emailValidation = (value: string) => {
  const valid = validateStringExists(value) && emailIsValid(value);

  if (valid) {
    return false;
  }

  return 'Please enter a valid email address';
};

export const numbersValidation = (value: string) => {
  const valid = !Number.isNaN(parseFloat(`${value}`));

  if (valid) {
    return false;
  }

  return 'Please enter a valid number';
};
